<template>
  <section id="specAndDoc">
    <div class="align">
      <h1>Условия и документы</h1>
      <div id="tabsMenu">
        <a href="" v-on:click.prevent="showTab(0)" v-bind:class="{active: activeTab == 0}">Требования к
          заемщику</a>
        <a href="" v-on:click.prevent="showTab(1)" v-bind:class="{active: activeTab == 1}">Условия выдачи
          займа</a>
        <a href="" v-on:click.prevent="showTab(2)" v-bind:class="{active: activeTab == 2}">Способы погашения</a>
        <a href="" v-on:click.prevent="showTab(3)" v-bind:class="{active: activeTab == 3}">Свидетельства</a>
      </div>
      <div id="tabsContent" ref="tabsContent">
        <div class="tabsContentItem">
          <div class="tabsMobilTitle"  v-on:click.prevent="showTab(0)">
            <span>Требования к заемщику</span>
            <IconBase viewBox="0 0 10.828 6.414" v-bind:class="{activeMobTitle: activeTab == 0}">
              <tabsIco></tabsIco>
            </IconBase>
          </div>
          <div class="content" v-show="activeTab == 0">
            <Conditions></Conditions>
          </div>
        </div>
        <div class="tabsContentItem">
          <div class="tabsMobilTitle"  v-on:click.prevent="showTab(1)">
            <span>Условия выдачи займа</span>
            <IconBase viewBox="0 0 10.828 6.414" v-bind:class="{activeMobTitle: activeTab == 1}">
              <tabsIco></tabsIco>
            </IconBase>
          </div>
          <div class="content" v-show="activeTab == 1" >
            <Repayment></Repayment>
          </div>
        </div>
        <div class="tabsContentItem">
          <div class="tabsMobilTitle"  v-on:click.prevent="showTab(2)">
            <span>Способы погашения</span>
            <IconBase viewBox="0 0 10.828 6.414" v-bind:class="{activeMobTitle: activeTab == 2}">
              <tabsIco></tabsIco>
            </IconBase>
          </div>
          <div class="content" v-show="activeTab == 2" >
            <Requirements></Requirements>
          </div>
        </div>
        <div class="tabsContentItem">
          <div class="tabsMobilTitle"  v-on:click.prevent="showTab(3)">
            <span>Свидетельства</span>
            <IconBase  viewBox="0 0 10.828 6.414" v-bind:class="{activeMobTitle: activeTab == 3}">
              <tabsIco></tabsIco>
            </IconBase>
          </div>
          <div class="content" v-show="activeTab == 3">
            <Testimonies></Testimonies>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "specificationAndDocumentation",
    data(){
      return{
        activeTab:0,
      }
    },
    components:{
      Conditions: () => import('@/components/section/specAndDoc/Conditions'),
      Repayment: () => import('@/components/section/specAndDoc/Repayment'),
      Requirements: () => import('@/components/section/specAndDoc/Requirements'),
      Testimonies: () => import('@/components/section/specAndDoc/Certificate'),
      IconBase:() => import('@/components/svg/IconBase'),
      tabsIco: () => import('@/components/svg/tabsIco'),
    },
    methods:{
      showTab(index){
        this.activeTab = (this.activeTab == index && window.innerWidth <= 760) ? -1 : index;
        this.$scrollTo('#specAndDoc', 150)
      },
    }
  }
</script>

<style scoped>
  #tabsMenu{display: none;}
  .tabsMobilTitle{display: flex;align-items: center;justify-content: space-between;padding: 5vw 0;border-bottom:
    3px solid #4AAF3D;}
  .tabsMobilTitle span{color:#4AAF3D;font-size: 5.6vw;}
  .tabsMobilTitle svg{width: 2vw;height: 2vw;}
  .activeMobTitle{transform: rotate(180deg)}

  /deep/.content{font-size: 5vw;padding: 5vw 0;}
  /deep/.content h2{font-size: 6.9vw;font-weight: bold;}
  /deep/.content p {margin: 3vw 0;}
  /deep/.content a{}

  /deep/ .pdfLink{}
  /deep/ .pdfLink a{display: flex;align-items: center;justify-content: space-between;margin: 5vw 0;color:#0D5A44}
  /deep/ .pdfLink a span{width: calc(100% - 15vw);}
  /deep/ .pdfLink a svg{width: 10vw;height: 10vw;}

  @media screen and (min-width: 760px) {
    section{padding-bottom: 0;}
    #tabsMenu{display: flex;width: 90vw;justify-content: space-between;padding: 3.5vw 0 0}
    #tabsMenu a{cursor: pointer;color:#4AAF3D;font-size: 1.6vw;font-weight: bold;text-decoration: none;position:
      relative;padding-bottom: 1.8vw;}
    #tabsMenu a:after{content: '';position: absolute;bottom: 0;left:50%;width: 0;height: 3px;background: transparent;transition: 0.3s ease-out}
    #tabsMenu a.active:after{left:0;width: 100%;background: #4AAF3D}
    .tabsMobilTitle{display: none}
    /deep/.content{font-size: 1.4vw;padding: 3.5vw 0;}
    /deep/.content h2{font-size: 2vw;}
    /deep/.content p {margin: 3vw 0;}
    /deep/.content a{}

    /deep/ .pdfLink{display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap}
    /deep/ .pdfLink a{display: flex;align-items: center;justify-content: space-between;margin: 2vw 0;color:#0D5A44;width: 30%}
    /deep/ .pdfLink a span{width: calc(100% - 4vw);}
    /deep/ .pdfLink a svg{width: 2.8vw;height: 2.8vw;}

    #tabsContent{width: 90vw;}
  }
  @media screen and (min-width: 1140px) {
    section{padding-bottom: 30px;}
    #tabsMenu{width: 1024px;padding-top: 40px;}
    #tabsMenu a{font-size: 18px;padding-bottom: 20px;}
    /deep/.content{font-size: 16px;padding: 30px 0 10px;}
    /deep/.content h2{font-size: 22px;font-weight: bold;}
    /deep/.content p {margin: 5px 0;}
    /deep/.content a{}

    /deep/ .pdfLink{}
    /deep/ .pdfLink a{display: flex;align-items: center;justify-content: space-between;margin: 15px 0;color:#0D5A44}
    /deep/ .pdfLink a span{width: calc(100% - 45px);}
    /deep/ .pdfLink a svg{width: 32px;height: 32px;}
    #tabsContent{width: 1024px;}
  }
</style>
